// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__34u1A","overflowing":"ReadFullNote_overflowing__1iPsJ"};